import { App, AppOptions, ViewConfig, getTagFromKey } from 'dwv'
export default {
  methods: {
    async getMetaData (files = []) {
      const data = []
      for await (const file of files) {
        await new Promise((resolve) => {
          // [] New DWV Object
          const viewConfig0 = new ViewConfig()
          const viewConfigs = { '*': [viewConfig0] }
          const options = new AppOptions(viewConfigs)
          const dwv = new App()
          dwv.init(options)
          dwv.addEventListener('loadend', (event) => {
            try {
              const meta = dwv.getMetaData(event.dataid)
              const metaData = this.getMetaDataWithNames(meta)
              data.push(metaData)
            } catch (error) {
              // console.error(error.message)
              this.$swal.fire({
                icon: 'error',
                title: 'ไฟล์ที่ไม่รองรับ',
                text: 'ไฟล์นี้ไม่รองรับและไม่สามารถอัปโหลดได้'
              })
              return
            }
            resolve()
          })
          // [x] Load file
          dwv.loadFiles([file])
        })
      }
      return data
    },
    getMetaDataWithNames (metaData) {
      function getTagKeysReducer (dataElements) {
        return function (accumulator, currentValue) {
          const tag = getTagFromKey(currentValue)
          let tagName = tag.getNameFromDictionary()
          if (typeof tagName === 'undefined') {
            tagName = 'x' + tag.getKey()
          }
          const currentMeta = dataElements[currentValue]
          for (const property in currentMeta) {
            if (typeof currentMeta[property] === 'undefined') {
              delete currentMeta[property]
            }
          }
          if (currentMeta.vr === 'SQ') {
            for (let i = 0; i < currentMeta.value.length; ++i) {
              const item = currentMeta.value[i]
              currentMeta.value[i] = Object.keys(item).reduce(
                getTagKeysReducer(item),
                {}
              )
            }
          }
          accumulator[tagName] = currentMeta
          return accumulator
        }
      }
      let meta = structuredClone(metaData)
      try {
        if (typeof meta['00020010'] !== 'undefined') {
          meta = Object.keys(meta).reduce(getTagKeysReducer(meta), {})
        }
      } catch (error) {
        console.log('Not Dicom')
      }
      return meta
    }
  }
}
